module.exports = __webpack_public_path__ + "assets/img/btn-view-ba69fa63.png";